import { render, staticRenderFns } from "./CP.vue?vue&type=template&id=0da81952&scoped=true"
import script from "./CP.vue?vue&type=script&lang=js"
export * from "./CP.vue?vue&type=script&lang=js"
import style0 from "./CP.vue?vue&type=style&index=0&id=0da81952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da81952",
  null
  
)

export default component.exports